import { AssignedConversation } from "@doktor-se/bones-ui/dist/web-shared/types"

import { featureFlags } from "config"
import { SearchPageConversation } from "types"

export const checkDeclineCall = (conversation: SearchPageConversation | AssignedConversation) => {
  switch (conversation.callState) {
    case "incoming":
      return "declined"
    case "outgoing":
      return "no_answer"
    case "active":
      return "hangup"
    default:
      return
  }
}
export const showAdditionalColumn = (list: any[]) => featureFlags.has("errand_details_view") && list.length > 0
